import { Http} from '@angular/http';
import {HttpClient} from "@angular/common/http";
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

import { environment } from '../../../environments/environment';

@Injectable()
export class WorkService {

    constructor(private http: HttpClient, private http2: Http) {}

    all(req){
        req.activeSort = req.activeSort || 'id';
        req.sortDirection = req.sortDirection || 'asc';
        req.page = req.page || 1; //default first page
        req.perPage = req.perPage || 5; //default no limit
        req.filter = req.filter || '';
        req.trash = req.trash || '';

        req.filterBranch = req.filterBranch || '';
        req.filterStatus = req.filterStatus || '';
        req.quote = req.quote || '';

        let requestUrl = environment.apiUrl + 'task/all';
        requestUrl += "?page=" + req.page + "&perPage=" + req.perPage + "&activeSort=" + req.activeSort + "&sortDirection=" + req.sortDirection + "&filter=" + req.filter + "&trash=" + req.trash + "&filterStatus=" + req.filterStatus + "&filterBranch=" + req.filterBranch + "&quote=" + req.quote;

        return this.http.get(requestUrl).map( (res: any) => {
            console.log(JSON.stringify(res))
            // its getting too much -no need it- output data
            return res;
        });
    }

    add(work){
        let requestUrl = environment.apiUrl + 'task/store';

        return this.http.post(requestUrl, work).map( (res: any) => {
            return res;
        });
    }

    edit(work){
        let requestUrl = environment.apiUrl + 'task/update/' + work.id;

        return this.http.put(requestUrl, work).map( (res: any) => {
            return res;
        });
    }

    get(id){
        let requestUrl = environment.apiUrl + 'task/get/' + id;

        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    getStudies(id){
        let requestUrl = environment.apiUrl + 'task/getStudies/' + id;

        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    getWorkers(id){
        let requestUrl = environment.apiUrl + 'task/getWorkers/' + id;

        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    restore(id){
        let requestUrl = environment.apiUrl + 'task/restore/' + id;

        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    delete(id, forceDelete){
        let requestUrl = environment.apiUrl + 'task/delete/' + id;

        if(forceDelete){
            requestUrl += '?forceDelete=1';
        }

        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });

    }

    //special method to get currency USD
    getCurrencyUSD(){
        let requestUrl = environment.apiUrl + 'task/getCurrencyUSD';

        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    addPayment(payment){
        let requestUrl = environment.apiUrl + 'task/addPayment';

        return this.http.post(requestUrl, payment).map( (res: any) => {
            return res;
        });
    }

    deletePayment(payment_id, service_id){
        let requestUrl = environment.apiUrl + 'task/deletePayment';

        return this.http.post(requestUrl, {payment_id: payment_id, service_id: service_id}).map( (res: any) => {
            return res;
        });
    }


    paymentsPDF(id){
        let requestUrl = environment.apiUrl + 'task/pdf/payments/' + id;

        return this.http.get(requestUrl, {responseType: 'blob' }).map( (res: any) => {
            return res;
        });
    }

    resultsPDF(id, worker_id, selectedStudies){
        let studies = '_';

        if(selectedStudies.length > 0){
            for(let study of selectedStudies){
                studies += study.id + '_';
            }
        }

        let requestUrl = environment.apiUrl + 'task/pdf/results/' + id + '/' + worker_id + '/' + studies;

        return this.http.get(requestUrl, {responseType: 'blob' }).map( (res: any) => {
            return res;
        });
    }

    studiesLabelPDF(id){
        let requestUrl = environment.apiUrl + 'task/pdf/label/' + id ;

        return this.http.get(requestUrl, {responseType: 'blob' }).map( (res: any) => {
            return res;
        });
    }

    resultsByEmail(id, worker_id, selectedStudies){
        let studies = '_';

        if(selectedStudies.length > 0){
            for(let study of selectedStudies){
                studies += study.id + '_';
            }
        }

        // url append number 1 flag
        let requestUrl = environment.apiUrl + 'task/pdf/resultsByEmail/' + id + '/' + worker_id + '/' + studies + '/' + '1' ;

        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    getCreditedServices(external_company_id){
        let requestUrl = environment.apiUrl + 'task/credited_services/' + external_company_id;

        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }
}



// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/services/work.service.ts